import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/bigData';
const bigData: Array<RouteConfig> = [
    {
        path: 'basic-info/big-data',
        name: 'bigData',
        redirect: { name: 'goodstype' },
        meta: {
            menuMatch: 'bigData',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'item',
                name: 'item',
                component: () => import(`@/${BASE_PATH}/Item.vue`),
                meta: {
                    index: '9-1',
                },
            },
            {
                path: 'collection',
                name: 'collection',
                component: () => import(`@/${BASE_PATH}/Collection.vue`),
                meta: {
                    index: '9-2',
                },
            },
        ],
    },
];
export default bigData;